import React from "react";
// import { useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { useState } from "react";

// import navigation data
import { navigationData } from "../../dataEn";

const Nav = ({ currentLanguage, onChangeLanguage }) => {
  const code = currentLanguage === "id" ? "ID" : "GB";
  return (
    <nav>
      <ul className="flex gap-x-8">
        {navigationData.map((item, index) => {
          return (
            <li key={index}>
              <a href={item.href}>{item.name}</a>
            </li>
          );
        })}
        <div className="flex items-center gap-x-1">
          <ReactCountryFlag countryCode={code} svg />
          <select
            id="countries"
            className="h5 text-primary font-semibold bg-transparent border-none cursor-pointer outline-none"
            value={currentLanguage}
            onChange={(e) => onChangeLanguage(e.target.value)}
          >
            <option value="en">EN</option>
            <option value="id">ID</option>
          </select>
        </div>
      </ul>
    </nav>
  );
};

export default Nav;
